import firebase from 'firebase/app';
import 'firebase/messaging';
import config from './component/config';

const firebaseConfig = {
  apiKey: "AIzaSyCppMFHNXmj9ZY54f7-kmM2287LSLCawyU",
  authDomain: "mobyads-ee40d.firebaseapp.com",
  databaseURL: "https://mobyads-ee40d.firebaseio.com",
  projectId: "mobyads-ee40d",
  storageBucket: "mobyads-ee40d.appspot.com",
  messagingSenderId: "335145993405",
  appId: "1:335145993405:web:21ab47c3c4cfbd199d23d4"
};

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

let messaging = null;
if (firebase.messaging.isSupported()) {
    messaging = firebase.messaging();
}

export const askForPermissionToReceiveNotifications = async () => {
  if (!messaging) return;
  try {
    const permission = await Notification.requestPermission();
    if (permission === 'granted') {
      // Check if the app moved from Browser Tab to Installed PWA (Standalone mode)
      const currentMode = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true ? 'standalone' : 'browser';
      const storedMode = localStorage.getItem('fcmTokenDisplayMode');

      if ((storedMode && storedMode !== currentMode) || (!storedMode && currentMode === 'standalone')) {
        // App environment changed (e.g., from browser to installed WebAPK PWA), 
        // OR an older user is running the PWA before this tracker existed.
        // This invalidates the old push token on the Android device level.
        // We must delete the old Token so Firebase is forced to mint a fresh valid one.
        console.log('App mode changed or old standalone user detected. Deleting old token to get a new one.');
        await messaging.deleteToken();
      }

      const token = await messaging.getToken();
      console.log('Firebase Token:', token);
      
      localStorage.setItem('fcmTokenDisplayMode', currentMode);

      if (token) {
        saveTokenToBackend(token);
      }

      // Listen for any native token refresh events from Firebase
      messaging.onTokenRefresh(async () => {
        try {
          const refreshedToken = await messaging.getToken();
          console.log('Firebase Token refreshed automatically:', refreshedToken);
          saveTokenToBackend(refreshedToken);
        } catch (e) {
          console.error('Unable to retrieve refreshed token', e);
        }
      });

      return token;
    }
  } catch (error) {
    console.error('Error getting notification permission:', error);
  }
}

export const syncFcmTokenWithBackend = (token = null) => {
  const fcmToken = token || localStorage.getItem('pendingFcmToken');
  const userPhone = localStorage.getItem('userPhone');
  const lastSavedToken = localStorage.getItem('savedFcmToken');

  // Only call the API if we have a token, a phone number, and the token hasn't already been saved
  if (fcmToken && userPhone && userPhone !== "" && userPhone !== "null") {
    if (fcmToken === lastSavedToken) {
        console.log('FCM Token is already synced. Skipping API call.');
        return;
    }

    const formBody = { 
        fsAction: 'saveFcmToken', 
        fsFcmToken: fcmToken,
        fsUserContact: userPhone 
    };
    config.fetchInformation(formBody).then((response) => {
      console.log('FCM Token synced with PHP backend:', response);
      localStorage.setItem('savedFcmToken', fcmToken); // Mark as saved
      localStorage.removeItem('pendingFcmToken');
    });
  } else if (fcmToken) {
    localStorage.setItem('pendingFcmToken', fcmToken);
  }
};

const saveTokenToBackend = (token) => {
    syncFcmTokenWithBackend(token);
};

export const onMessageListener = () =>
  new Promise((resolve) => {
    if (!messaging) return;
    messaging.onMessage((payload) => {
      resolve(payload);
    });
  });
